
import { Component, Vue, Watch } from "vue-property-decorator";
import moment from "moment";
import { VMoney } from "v-money";

@Component({
  components: {},
  computed: {},
  filters: {},
  watch: {},
  directives: { money: VMoney }
})
export default class NewRequestAeronavegacion extends Vue {
  title: string = "Crear Solicitud";
  isLoading: boolean = false;
  coinsurance_companies: any = [];
  data: any = {
    insured_fullname: {
      value: "",
      label: "Nombre de los Asegurados"
    },
    country: {
      value: "",
      label: "País"
    },
    city: {
      value: "",
      label: "Ciudad"
    },
    aircraft_identification: {
      value: "",
      label: "Identificación de la Aeronave"
    },
    province: {
      value: "",
      label: "Estado / Provincia"
    },
    address: {
      value: "",
      label: "Dirección"
    },
    zipcode: {
      value: "",
      label: "Código postal"
    },
    branchcertificate: {
      value: "",
      label: "Rama"
    },
    total_value_risks: {
      value: "",
      label: "Valores Totales a Riesgo",
      options: {
        coinsurance_participation: {
          value: false,
          label: "Participación en el Coaseguro"
        },
        excluded_from_contract: {
          value: false,
          label: "Excluido del Contrato"
        }
      }
    },
    total_sum_secured: {
      value: "",
      label: "Suma Total Asegurada"
    },
    aon_sum: {
      value: "",
      label: "Suma Cedida a AON",
      options: {
        special_aceptation: {
          value: false,
          label: "Aceptación Especial"
        }
      }
    },
    facultative_sum: {
      value: "",
      label: "Suma Cedida a Facultativos"
    },
    retained_sum: {
      value: "",
      label: "Suma Retenida + Cesión a Contratos"
    },
    aon_sum_extra: {
      value: "",
      label: "Suma Extra Cedida a AON"
    },
    original_tax: {
      value: "",
      label: "Tasa Original"
    },
    original_gross_bonus: {
      value: "",
      label: "Prima Bruta Original Anual"
    },
    original_gross_bonus_parcial: {
      value: "",
      label: "Prima Bruta Original por el periodo"
    },
    original_gross_aon: {
      value: "",
      label: "Prima Bruta Cedida a AON"
    },
    notes: {
      value: '',
      label: 'Observaciones',
    },
    money: {
      decimal: ",",
      thousands: ".",
      prefix: "",
      suffix: "",
      precision: 2,
      masked: true
    },
    coordinate_lat: 0,
    coordinate_lng: 0
  };
  subscriptor: any = "";
  bien: any = null;
  conditions: any = {};
  currency: any = {};
  controlzones: any = {};
  company: any = "";
  branch: any = null;
  countries: any = null;
  companies: any = null;

  autocomplete: any = null;

  async onDataChange(calculate_tax_first) {
    let bien: any = this.getBien();
    let data: any = await (this as any).validateBien(bien, calculate_tax_first);
    Object.keys(data.data).forEach(key => {
      if (this.data[key]) this.data[key].value = data.data[key];
    });
    if (data.error) {
      (this.$root as any).notify(data.error, "warn");
    }
  }

  async mounted() {
    this.subscriptor = this.$store.state.user.fullname;
    this.loadControlZones();
    this.loadCompany();
    this.loadCompanies();
    this.loadConditions();
    this.loadCurrencies();
    this.loadBranches();
    this.loadCountries();
    this.initGoogleAutocomplete();
    this.fillInAddress();
  }

  initGoogleAutocomplete() {
    var options = {
      types: ['address'],
      componentRestrictions: {country: ["ar", "cl", "uy", "py"]}
    };

     this.autocomplete = new google.maps.places.Autocomplete(
       (this.$refs.autocomplete) as HTMLInputElement,
       options);
      this.autocomplete.setFields(['address_components', 'geometry', 'icon', 'name']);
      this.autocomplete.addListener('place_changed', this.fillInAddress);
  }

  fillInAddress() {
      var place = this.autocomplete.getPlace();
        

      var map = new google.maps.Map( document.getElementById("map"), {
           center: {lat: -34.6177, lng: -58.3621},
           zoom: 3
        });
        if (!place)  return;
        var marker = new google.maps.Marker({
          map: map,
          anchorPoint: new google.maps.Point(0, -29)
        });
        
        if (place.geometry.viewport) {
          map.fitBounds(place.geometry.viewport);
        } else {
          map.setCenter(place.geometry.location);
          map.setZoom(17);
        }
        marker.setPosition(place.geometry.location);
        marker.setVisible(true);

      this.data.address.value = place.address_components.find(e => e.types[0] === "route").long_name + ' ' + (place.address_components.find(e => e.types[0] === "street_number") ? place.address_components.find(e => e.types[0] === "street_number").long_name : "");
      this.data.country.value = place.address_components.find(e => e.types[0] === "country") ? place.address_components.find(e => e.types[0] === "country").long_name : "";
      this.data.province.value = place.address_components.find(e => e.types[0] === "administrative_area_level_1") ? place.address_components.find(e => e.types[0] === "administrative_area_level_1").long_name : "";    
      this.data.city.value = place.address_components.find(e => e.types[0] === "administrative_area_level_2") ? place.address_components.find(e => e.types[0] === "administrative_area_level_2").long_name : "";
      this.data.zipcode.value = place.address_components.find(e => e.types[0] === "postal_code") ? place.address_components.find(e => e.types[0] === "postal_code").long_name : "";   
      this.data.coordinate_lat = place.geometry.location.lat();      
      this.data.coordinate_lng = place.geometry.location.lng();
  }


  async loadCompanies() {
    let companies: any = [];
    let today = moment();
    const response: any = await (this.$root as any)._post("companies/all", {
      skipRole: true
    });
    response.data.forEach(c => {
      if (this.$store.state.companyId === c.id) return;
      if (this.$store.state.user.companies[0].countryId !== c.countryId) return;
      if (
        moment(c.date_request_from).isBefore(today) &&
        moment(c.date_request_to).isAfter(today)
      ) {
        companies.push(c);
      }
    });
    this.companies = companies;
  }

  async loadConditions() {
    this.conditions = { ...this.$store.state.newRequest.conditions };
  }

  async loadControlZones() {
    const user: any = await (this.$root as any)._post(
      `subscriptors/one/${this.$store.state.user.id}`,
      { models: "companies" }
    );
    const company: any = user.data[0].companies[0];
    const response: any = await (this.$root as any)._post("controlzones/all", {
      countryId: company.countryId
    });
    this.controlzones = response.data;
  }

  async loadCompany() {
    this.company = this.$store.state.user.companies.filter(
      c => c.id === this.$store.state.companyId
    )[0].name;
  }

  async loadBranches() {
    const response: any = await (this.$root as any)._get(
      `branches/one/${this.$store.state.newRequest.branch}`
    );
    this.branch = response.data[0].title;
  }

  async loadCurrencies() {
    const response: any = await (this.$root as any)._get("currencies/all");
    this.currency = response.data.filter(
      c => c.id === this.conditions.currency_id
    )[0].title;
  }

  async loadCountries() {
    const response: any = await (this.$root as any)._get("countries/all");
    this.countries = response.data;
  }

  prevStep() {
    this.$router.push("/requests/new-request/conditions");
  }

  cancelNewRequest() {
    this.$store.commit("clearNewRequest");
  }

  getBien() {
    // let country: any = (this as any).countries.find(
    //   (i: any) => i.id === (this as any).data.country.value
    // );
    return {
      rdCountry: this.data.country.value,    
      branchId: this.$store.state.newRequest.branch,
      insured_fullname: this.data.insured_fullname.value,
      city: this.data.city.value,
      coordinate_lat: this.data.coordinate_lat,
      coordinate_lng: this.data.coordinate_lng,
      aircraft_identification: this.data.aircraft_identification.value,
      province: this.data.province.value,
      address: this.data.address.value,
      branchcertificate: this.data.branchcertificate.value,
      total_value_risks: this.data.total_value_risks.value,
      coinsurance_participation: this.data.total_value_risks.options
        .coinsurance_participation.value,
      excluded_from_contract: this.data.total_value_risks.options
        .excluded_from_contract.value,
      total_sum_secured: this.data.total_sum_secured.value,
      aon_sum: this.data.aon_sum.value,
      special_aceptation: this.data.aon_sum.options.special_aceptation.value,
      facultative_sum: this.data.facultative_sum.value,
      retained_sum: this.data.retained_sum.value,
      aon_sum_extra: this.data.aon_sum_extra.value,
      original_tax: this.data.original_tax.value,
      original_gross_bonus: this.data.original_gross_bonus.value,
      original_gross_bonus_parcial: this.data.original_gross_bonus_parcial
        .value,
      original_gross_aon: this.data.original_gross_aon.value,
      notes: this.data.notes.value,
      companyId: this.$store.state.companyId,
      policy_number: this.conditions.policy_number,
      assignmentValidityAonFrom: this.conditions.assignmentValidityAonFrom,
      assignmentValidityAonTo: this.conditions.assignmentValidityAonTo,
      validity_from: this.conditions.validity_from,
      validity_to: this.conditions.validity_to,
      assignment_percent_aon: this.conditions.assignment_percent_aon,
      controlZoneId: this.conditions.controlZoneId,
      currencyId: this.conditions.currency_id,
      modifyType: 0
    };
  }

  async validateBien(bien: any, calculate_tax_first: boolean) {
    let validateBien: any = {
      branchId: this.$store.state.newRequest.branch,
      companyId: this.$store.state.companyId,
      currencyId: this.conditions.currency_id,
      facultative_sum: bien.facultative_sum,
      original_gross_bonus: bien.original_gross_bonus,
      original_gross_bonus_parcial: bien.original_gross_bonus_parcial,
      original_tax: bien.original_tax,
      aon_sum: bien.aon_sum,
      aon_sum_extra: bien.aon_sum_extra,
      retained_sum: bien.retained_sum,
      total_sum_secured: bien.total_sum_secured,
      total_value_risks: bien.total_value_risks,
      yeardays: moment(this.conditions.validity_to, "DD/MM/YYYY").diff(
        moment(this.conditions.validity_from, "DD/MM/YYYY"),
        "days"
      ),
      period: moment(
        this.conditions.assignmentValidityAonTo,
        "DD/MM/YYYY"
      ).diff(
        moment(this.conditions.assignmentValidityAonFrom, "DD/MM/YYYY"),
        "days"
      )
    };
    [
      "aon_sum",
      "aon_sum_extra",
      "facultative_sum",
      "original_gross_aon",
      "original_gross_bonus",
      "original_gross_bonus_parcial",
      "original_tax",
      "retained_sum",
      "total_sum_secured",
      "total_value_risks"
    ].forEach(key => {
      if (validateBien[key])
        validateBien[key] = parseFloat(
          String(validateBien[key])
            .replace(/\./g, "")
            .replace(/,/g, ".")
        );
    });
    validateBien.calculate_tax_first = calculate_tax_first ? 1 : 0;
    try {
      const response: any = await (this.$root as any)._post(
        "requests/validateform",
        validateBien
      );
      return response;
    } catch (e) {
      (this.$root as any).notify(e, "error");
      return false;
    }
  }

  async agregarBien() {
    if (!this.bien) {
      let bien: any = this.getBien();
      let response: any = (this as any).validateBien(bien);
      if (response) {
        this.bien = { ...bien, ...response.data };
      }
    }
  }

  eliminarBien() {
    this.bien = null;
  }

  async nextStep() {
    if (this.bien && !this.isLoading) {
      this.isLoading = true;
      this.$modal.show("loading");

      try {
        let data = this.bien;
        [
          "aon_sum",
          "aon_sum_extra",
          "facultative_sum",
          "original_gross_aon",
          "original_gross_bonus",
          "original_gross_bonus_parcial",
          "original_tax",
          "retained_sum",
          "total_sum_secured",
          "total_value_risks"
        ].forEach(key => {
          if (data[key])
            data[key] = parseFloat(
              String(data[key])
                .replace(/\./g, "")
                .replace(/,/g, ".")
            );
        });
        data.original_gross_bonus_anual = data.original_gross_bonus;
        data.original_gross_bonus = data.original_gross_bonus_parcial;
        data.countryId = this.$store.state.user.companies[0].countryId;
        data.controlZoneId =
          data.controlZoneId == "NULL" ? null : data.controlZoneId;
        data.coinsurance_companies = this.coinsurance_companies.join(",");
        data.assignment_percent_aon = data.assignment_percent_aon
          .replace(/%/g, "")
          .replace(/\./g, "")
          .replace(/,/g, ".");

        const res: any = await (this.$root as any)._post("requests", data);

        this.$modal.hide("loading");
        (this.$root as any).notify("Solicitud creada con éxito!", "success");
        setTimeout(() => this.$store.commit("clearNewRequest"), 3000);
      } catch (e) {
        this.$modal.hide("loading");
        (this.$root as any).notify(e, "error");
      }

      this.isLoading = false;
    }
  }
}
